/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacyExternalOrderItems } from 'app/entities/pharmacy-external-order-item/pharmacy-external-order-item.reducer';
import { getEntities as getPharmacyExternalOrderShipments } from 'app/entities/pharmacy-external-order-shipment/pharmacy-external-order-shipment.reducer';
import { PharmacyProductType } from 'app/shared/model/enumerations/pharmacy-product-type.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-external-order-shipment-item.reducer';

export const PharmacyExternalOrderShipmentItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacyExternalOrderItems = useAppSelector(state => state.pharmacyExternalOrderItem.entities);
  const pharmacyExternalOrderShipments = useAppSelector(state => state.pharmacyExternalOrderShipment.entities);
  const pharmacyExternalOrderShipmentItemEntity = useAppSelector(state => state.pharmacyExternalOrderShipmentItem.entity);
  const loading = useAppSelector(state => state.pharmacyExternalOrderShipmentItem.loading);
  const updating = useAppSelector(state => state.pharmacyExternalOrderShipmentItem.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyExternalOrderShipmentItem.updateSuccess);
  const pharmacyProductTypeValues = Object.keys(PharmacyProductType);

  const handleClose = () => {
    navigate(`/pharmacy-external-order-shipment-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacyExternalOrderItems({}));
    dispatch(getPharmacyExternalOrderShipments({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.shippedQty !== undefined && typeof values.shippedQty !== 'number') {
      values.shippedQty = Number(values.shippedQty);
    }
    if (values.receivedQty !== undefined && typeof values.receivedQty !== 'number') {
      values.receivedQty = Number(values.receivedQty);
    }
    if (values.packs !== undefined && typeof values.packs !== 'number') {
      values.packs = Number(values.packs);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.freeQty !== undefined && typeof values.freeQty !== 'number') {
      values.freeQty = Number(values.freeQty);
    }

    const entity = {
      ...pharmacyExternalOrderShipmentItemEntity,
      ...values,
      orderItem: pharmacyExternalOrderItems.find(it => it.id.toString() === values.orderItem?.toString()),
      shipment: pharmacyExternalOrderShipments.find(it => it.id.toString() === values.shipment?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          productType: 'CONSUMABLE',
          ...pharmacyExternalOrderShipmentItemEntity,
          orderItem: pharmacyExternalOrderShipmentItemEntity?.orderItem?.id,
          shipment: pharmacyExternalOrderShipmentItemEntity?.shipment?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.home.createOrEditLabel"
            data-cy="PharmacyExternalOrderShipmentItemCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.home.createOrEditLabel">
              Create or edit a PharmacyExternalOrderShipmentItem
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-external-order-shipment-item-id"
                  label={translate('tinyMedicRestApp.pharmacyExternalOrderShipmentItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipmentItem.shippedQty')}
                id="pharmacy-external-order-shipment-item-shippedQty"
                name="shippedQty"
                data-cy="shippedQty"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipmentItem.receivedQty')}
                id="pharmacy-external-order-shipment-item-receivedQty"
                name="receivedQty"
                data-cy="receivedQty"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipmentItem.packs')}
                id="pharmacy-external-order-shipment-item-packs"
                name="packs"
                data-cy="packs"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipmentItem.productType')}
                id="pharmacy-external-order-shipment-item-productType"
                name="productType"
                data-cy="productType"
                type="select"
              >
                {pharmacyProductTypeValues.map(pharmacyProductType => (
                  <option value={pharmacyProductType} key={pharmacyProductType}>
                    {translate(`tinyMedicRestApp.PharmacyProductType.${pharmacyProductType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipmentItem.productId')}
                id="pharmacy-external-order-shipment-item-productId"
                name="productId"
                data-cy="productId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipmentItem.active')}
                id="pharmacy-external-order-shipment-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipmentItem.cursor')}
                id="pharmacy-external-order-shipment-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipmentItem.lastUpdated')}
                id="pharmacy-external-order-shipment-item-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipmentItem.microSec')}
                id="pharmacy-external-order-shipment-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipmentItem.timestampEntry')}
                id="pharmacy-external-order-shipment-item-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipmentItem.purchaseBillItemId')}
                id="pharmacy-external-order-shipment-item-purchaseBillItemId"
                name="purchaseBillItemId"
                data-cy="purchaseBillItemId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipmentItem.freeQty')}
                id="pharmacy-external-order-shipment-item-freeQty"
                name="freeQty"
                data-cy="freeQty"
                type="text"
              />
              <UncontrolledTooltip target="freeQtyLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.help.freeQty" />
              </UncontrolledTooltip>
              <ValidatedField
                id="pharmacy-external-order-shipment-item-orderItem"
                name="orderItem"
                data-cy="orderItem"
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipmentItem.orderItem')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyExternalOrderItems
                  ? pharmacyExternalOrderItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-external-order-shipment-item-shipment"
                name="shipment"
                data-cy="shipment"
                label={translate('tinyMedicRestApp.pharmacyExternalOrderShipmentItem.shipment')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyExternalOrderShipments
                  ? pharmacyExternalOrderShipments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/pharmacy-external-order-shipment-item"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyExternalOrderShipmentItemUpdate;
